import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import { formatNumber } from "@/utilities/formatNumber";

/** Footer of a list cut by `useShowMore`; renders nothing once every item is shown. */
export function ShowMoreButton({ hiddenCount, onClick }: { hiddenCount: number; onClick: () => void }) {
  const { t, i18n } = useTranslation();
  if (hiddenCount <= 0) return null;
  return (
    <Button size="small" onClick={onClick} sx={{ alignSelf: "center" }}>
      {t("common.showMore", { hidden: formatNumber(hiddenCount, i18n.language) })}
    </Button>
  );
}
